module.exports = __webpack_public_path__ + "static/media/vector-left.64aad524.svg";